export default __webpack_public_path__ + "9e4dc18e22b74e493dec876a6cd944ae.jpg";